import * as model from "../models";
import { CategoryActions, SaveCategories, CategoryFormActions, BoxOfficeActions } from "../actions"
export const CATEGORY_TYPES: string[] = ["CATEGORY_1", "CATEGORY_2", "CATEGORY_3", "CATEGORY_4", "CATEGORY_5", "CATEGORY_6", "CATEGORY_7",
	"CATEGORY_8", "CATEGORY_9", "CATEGORY_10"]

export interface CategoryState {
	loaded: boolean;
	loading: boolean;
	errors: boolean;
	categories: model.Category[];
	collectionUrl: string;
};

const initialState: CategoryState  = {
	loaded: false,
	loading: false,
	errors: false,
	categories: [],
	collectionUrl: null
}

export const categoryReducer = (state = initialState, action) => {
	switch (action.type) {

		case CategoryActions.CLEAR_STATE:
		case BoxOfficeActions.CLEAR_EVENTSERVER_STATE:
			return initialState

		case CategoryActions.LOAD_COLLECTION_SUCCESS:
			return {
				loaded: true,
				loading: false,
				errors: false,
				categories: action.payload,
				collectionUrl: state.collectionUrl
			}

		case CategoryActions.LOAD_COLLECTION:
			return {
				loaded: false,
				loading: true,
				errors: false,
				categories: [],
				collectionUrl: action.payload
			}

		case CategoryFormActions.CATEGORY_AND_PRICELEVEL_SAVED:
			return {
				loaded: true,
				errors: false,
				loading: false,
				categories: action.payload.categories,
				collectionUrl: state.collectionUrl
			}

		default: {
			return state;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/reducers/category.reducer.ts